
import React, { useEffect } from 'react';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';

import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import Check from '@material-ui/icons/Check';

import DoNotDisturbAltIcon from '@material-ui/icons/Close';
import SentimentDissatisfied from '@material-ui/icons/SentimentDissatisfied';
export default function LastVerification({themoImages,tapisThermocouple,comm, vacuumImage,myimagelist, logoim, entete, numberplies, remarks, description, information }) {
    var empties = entete.length - entete.filter(String).length;
    var emptiRemarks = remarks.length - remarks.filter(String).length;
    
    var imagelistCalculator = vacuumImage.length;

    return (<>
        <div className="stopwatch">
            <span style={{ width: "80vh" }}>

                <h5>Last verification :</h5>

                <table id="customerss">
                    <tr>
                        <th>Section</th>
                        <th>Note</th>
                        <th>Include in the report ?</th>
                    </tr>
                    <tr>
                        <td> Report Header  </td>
                        <td>
                            <table id="customers">
                                <td COLSPAN="2">
                                    {empties == 0 ? <SentimentVerySatisfiedIcon style={{ color: 'green' }} /> : <SentimentVeryDissatisfiedIcon style={{ color: 'red' }} />}

                                </td>
                                {empties == 0 ?
                                    <tr>
                                        <td>No empty field(s) </td>
                                        <td> <Check style={{ color: 'green' }} /></td>
                                    </tr> :
                                    <tr>
                                        <td>Nb of empty field(s) {empties} </td>
                                        <td> <DoNotDisturbAltIcon style={{ color: 'red' }} /></td>
                                    </tr>
                                }
                            </table>
                        </td>
                        <td>Yes/No</td>
                    </tr>
                    <tr>
                        <td>Vacuum Bag  </td>
                        <td>
                            <table id="customers">
                            {typeof information[1] !== "undefined" && information[1] !== null && information.length[1] !== null ?
                                <td COLSPAN="2"><SentimentSatisfiedAltIcon style={{ color: 'green' }} /></td>:<td COLSPAN="2"><SentimentVeryDissatisfiedIcon style={{ color: 'red' }} /></td>}
                                <tr>
                                    <td>Nb of Layer(s) configured {typeof information[1] !== "undefined" && information[1] !== null && information[1].length !== null ?information[1].length:null} </td>
                                    {typeof information[1] !== "undefined" && information[1] !== null && information.length[1] !== null ?
                           
                           <td><Check style={{ color: 'green' }} /></td>:<td><DoNotDisturbAltIcon style={{ color: 'red' }} /></td>}

                                </tr>
                                <tr>
                                    <td>Remark added  </td>
                                    <td> {comm===""? <DoNotDisturbAltIcon style={{ color: 'red' }} /> : <Check style={{ color: 'green' }} />}   </td>

                                </tr>
                                <tr>
                                    <td>Pictures added {imagelistCalculator} </td>
                                    <td> {imagelistCalculator===0? <DoNotDisturbAltIcon style={{ color: 'red' }} /> : <Check style={{ color: 'green' }} />}   </td>

                                </tr>
                            </table >
                        </td>
                        <td>Yes/No</td>
                    </tr>



                    <tr>
                        <td> Layers Configuration </td>
                        <td><table id="customers"><td COLSPAN="2"><SentimentSatisfiedIcon style={{ color: 'blue' }} /></td>

                            <tr><td> Number of Plies {numberplies} </td>
                                <td> <Check style={{ color: 'green' }} /></td> </tr>

                            <tr><td>Nb of empty remark(s)    {emptiRemarks} </td>
                            {emptiRemarks===0?<td> <Check style={{ color: 'green' }} /></td>:<td> <DoNotDisturbAltIcon style={{ color: 'red' }} /></td>}
                                 </tr>

                           

                            <tr><td>
                                Water break test </td>
                                <td> {entete[28]==='Other' || entete[28]==='' ? <DoNotDisturbAltIcon style={{ color: 'red' }} />:<Check style={{ color: 'green' }} />}</td>  </tr>
                            <tr>
                                <td>Description added  </td>
                              
                                {description!=""?<td><Check style={{ color: 'green' }} /></td>:<td><DoNotDisturbAltIcon style={{ color: 'red' }} /></td>}
                                

                            </tr>
                        </table></td>
                        <td>Yes/No</td>
                    </tr>

                   



                    <tr>
                        <td>Heating Carpet and Thermocouples  </td>
                        <td>
                            <table id="customers">
                                <td COLSPAN="2">  <SentimentDissatisfiedIcon style={{ color: 'orange' }} /></td>
                                <tr>
                                    <td>{tapisThermocouple.length} elements added manually <br />
                                        <div style={{fontSize:12}}>(You can save up to 60% of your time using the <b>Zebra</b> terminal.<br /> <a href='#'>Click here for more info)</a></div> </td>
                                    <td>
                                        <DoNotDisturbAltIcon style={{ color: 'orange' }} />

                                    </td>

                                </tr>
                                <tr>
                                    <td>  Pictures added {themoImages.length}  </td>
                                    <td>   {themoImages.length>0?<Check style={{ color: 'green' }} />:<DoNotDisturbAltIcon style={{ color: 'red' }} />}</td>

                                </tr>
                            </table>
                        </td>
                        <td>Yes/No</td>
                    </tr>



                    <tr>
                        <td>Logo </td>

                        <td>
                            <table id="customers">
                                {logoim[0] != null ? <> <td COLSPAN="2">   <SentimentVerySatisfiedIcon style={{ color: 'green' }} />
                                </td></> : <> <td COLSPAN="2">   <SentimentDissatisfied style={{ color: 'red' }} />
                                </td></>}

                                <tr>
                                    <td>Logo added  </td>

                                    {logoim[0] != null ? <>  <td> <Check style={{ color: 'green' }} /></td></> : <>  <td> <DoNotDisturbAltIcon style={{ color: 'red' }} /></td></>}
                                </tr>

                            </table >
                        </td>
                        <td>Yes/No</td>
                    </tr>
                </table>






            </span>
        </div>
    </>)
}